const Authorization = () => import(/* webpackChunkName: 'wx' */ './authorization');
const Account = () => import(/* webpackChunkName: 'wx' */ './account');
const AccountList = () => import(/* webpackChunkName: 'wx' */ './accountlist');
const Success = () => import(/* webpackChunkName: 'wx' */ './success');
const Fail = () => import(/* webpackChunkName: 'wx' */ './fail');

const routes = [
  { path: '/wx', component: Authorization },
  { path: '/wx/account', component: Account },
  { path: '/wx/account/success', component: Success },
  { path: '/wx/account/fail', component: Fail },
  { path: '/wx/accountlist', component: AccountList }
];

export default routes;
